<template>
  <section class="event">
    <span class="total" :class="{hidden:!eventCount}">{{$t('global.共x个活动',{count:eventCount})}}</span>
    <div class="event-list">
      <div class="empty" v-if="eventCount === 0 && !loading">
        <img src="/static/v2/match/event_empty.png" alt />
        <p>{{$t('global.该频道还没有相关活动')}}</p>
      </div>
      <ul v-else>
        <li v-for="item in eventList" :key="item.id">
          <EventCard :item="item" />
        </li>
      </ul>
      <Loading v-if="loading" />
      <Reload v-if="loadError" @callback="loadMore" />
      <no-more v-if="!hasNextPage && eventList.length" /> 
    </div>
  </section>
</template>

<script>
import EventCard from "@/components/v2/match/eventCard.vue";
import Reload from "@/components/v2/match/reload";
import NoMore from "@/components/v2/NoMore";
import Loading from "@/components/v2/match/loading";
import {
  getScrollHeight,
  getScrollTop,
  getWindowHeight
} from "@/assets/screen";
export default {
  components: {
    EventCard,
    Reload,
    Loading,
    NoMore
  },
  data() {
    return {
      loading: false,
      hasMore: true,
      loadError: false,
      hasNextPage: true,
      pageIndex: 1,
      pageSize: 8,
      eventList: [],
      eventCount: 0,
      topicId: null
    };
  },
  created() {
    this.init();
  },
  mounted() {
    window.addEventListener("scroll", this.loadMore);
  },
  destroyed() {
    window.removeEventListener("scroll", this.loadMore, false);
  },
  methods: {
    init() {
      this.topicId = this.$route.params.id;
      this.getEventList();
    },
    loadMore() {
      if (getScrollTop() + getWindowHeight() >= getScrollHeight() - 20) {
        if (!this.loading && this.hasNextPage) {
          this.pageIndex++;
          this.getEventList();
        }
      }
    },
    getEventList() {
      this.loading = true;
      const url = "/api/2.0/topic/activityLiveList";
      const params = {
        topicId: this.topicId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      this.$http.get(url, { params }).then(res => {
        this.loading = false;
        if (res.code === "OK") {
          this.loadError = false;
          this.eventList = [...this.eventList, ...res.data.data.list];
          this.eventCount = res.data.data.totalRecord;
          this.hasNextPage = res.data.data.hasNextPage;
        } else {
          this.pageIndex--;
          this.loadError = true;
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.event {
  .total {
    display: block;
    color: #999999;
    font-size: 15px;
    font-weight: 500;
    padding: 30px 0;

    &.hidden {
      visibility: hidden;
    }
  }

  .event-list {
    padding-bottom: 40px;

    .empty {
      text-align: center;

      img {
        width: 88px;
        height: 88px;
      }

      p {
        font-size: 15px;
        padding-top: 30px;
        color: #B8B8B8;
      }
    }

    ul {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      li {
        width: 255px;
        height: 442px;
        margin: 0 30px 40px 0;

        &:nth-child(4n) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/v2/subject/channel/Event.vue